import {Routes} from '@angular/router';
import {MasterComponent} from './component/master/master.component';
import {ReservationGuard} from './guard/reservation.guard';
import {SessionGuard} from './guard/session.guard';
import {SetttingGuard} from './guard/settting.guard';


export const masterRouter: Routes = [
    {
        path: 'booking',
        canActivate: [ReservationGuard],
        component: MasterComponent,
        loadChildren: './../../modules/reservation/reservation.module#ReservationModule'
    },
    {
        path: 'log',
        component: MasterComponent,
        loadChildren: './../../modules/log/log.module#LogModule'
    },
    {
        path: 'session',
        canActivate: [SessionGuard],
        component: MasterComponent,
        loadChildren: './../../modules/session/session.module#SessionModule'
    },
    {
        path: 'setting',
        component: MasterComponent,
        canActivate: [SetttingGuard],
        loadChildren: './../../modules/setting/setting.module#SettingModule'
    },
    {
        path: 'charge',
        component: MasterComponent,
        canActivate: [SessionGuard],
        loadChildren: './../../modules/charge/charge.module#ChargeModule'
    }


];

